var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 24.5C9 15.9396 15.9396 9 24.5 9C33.0604 9 40 15.9396 40 24.5C40 28.7639 38.2783 32.6257 35.4921 35.4281C35.4807 35.4376 35.4696 35.4478 35.4589 35.4585C35.4482 35.4692 35.4381 35.4802 35.4286 35.4916C32.6262 38.2781 28.7642 40 24.5 40C15.9396 40 9 33.0604 9 24.5ZM35.8086 36.5153C32.8552 39.296 28.8766 41 24.5 41C15.3873 41 8 33.6127 8 24.5C8 15.3873 15.3873 8 24.5 8C33.6127 8 41 15.3873 41 24.5C41 28.8764 39.2962 32.8548 36.5157 35.8081L48.8541 48.1465C49.0493 48.3417 49.0493 48.6583 48.8541 48.8536C48.6588 49.0488 48.3422 49.0488 48.1469 48.8536L35.8086 36.5153Z",
  fill: "currentColor"
})));
export default SvgSearch56;